<template>
  <div v-if="value">
    <el-dialog
      title="奖励配置"
      :visible.sync="value"
      width="80%"
      :before-close="handleDialogClose"
    >
      <div class="main-text">签到天数: {{ rowData.days }}</div>
      <div class="main-text">渠道: {{ rowData.channel }}</div>
      <el-form ref="form" :inline="true" :model="formData">
        <el-form-item label="奖品类型:">
          <el-select v-model="formData.rewardType" placeholder="请选择">
            <el-option
              v-for="item in rewardTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="奖品id:">
          <el-input v-model="formData.prizeId"></el-input>
        </el-form-item>
        <el-form-item label="奖励数量/天数/积分:">
          <el-input v-model="formData.count"></el-input>
        </el-form-item>
        <el-button type="primary" @click="submitUpdateReward(false)">添加</el-button>
      </el-form>

      <el-table :data="rewardDetailTable" border style="width: 100%" height="520">
        <el-table-column prop="activityId" label="奖品id" width="120"></el-table-column>
        <el-table-column prop="type" label="奖品类型" width="180">
          <template slot-scope="scope">
            {{ rewardTypeList.find((item) => item.value === scope.row.type).label }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="奖励名称"></el-table-column>
        <el-table-column prop="activityType" label="是否有效">
          <template slot-scope="scope">
            {{ scope.row.valid === 1 ? "有效" : "无效" }}
          </template>
        </el-table-column>
        <el-table-column prop="nums" label="数量/天数/积分"></el-table-column>
        <el-table-column prop="operator" label="大图">
          <template slot-scope="scope">
            <img :src="scope.row.bigIcon" alt="" style="width: 50px" />
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="小图">
          <template slot-scope="scope">
            <img :src="scope.row.icon" alt="" style="width: 50px" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button type="warning" @click="dialogShow(scope.row)">编辑</el-button>
            <el-button type="danger" @click="deleteRowData(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      title="编辑"
      :visible.sync="editDialog.visible"
      width="40%"
      :before-close="handleInnerDialogClose"
    >
      <el-form ref="form" :model="editDialog.data">
        <el-form-item label="奖品名称:">
          <el-input v-model="editDialog.data.name"></el-input>
        </el-form-item>
        <el-form-item label="数量:">
          <el-input v-model="editDialog.data.nums"></el-input>
        </el-form-item>

        <UploadSingleImg v-model="editDialog.data.icon" :on-upload="uploadFile" />
        <UploadSingleImg v-model="editDialog.data.bigIcon" :on-upload="uploadFile" />

        <el-button type="primary" @click="submitUpdateReward(true)">确认</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { rewardTypeList } from "./reward.js";
import UploadSingleImg from "@/components/UploadSingleImg/UploadSingleImg";
import {
  getSignInDetailTable,
  updateSignInDetailTable,
  deleteSignInDetailTable,
} from "@/api/rewardConfigRequest";
export default {
  components: {
    UploadSingleImg,
  },
  props: {
    rowData: Object,
    value: Boolean,
  },
  data() {
    return {
      formData: {
        rewardType: null,
        count: "",
        prizeId: null,
      },
      rewardTypeList,
      dialogData: {
        visible: false,
      },
      rewardDetailTable: [],
      editDialog: {
        visible: false,
        data: {},
      },
    };
  },
  methods: {
    async uploadFile(file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("cover", 0);
      formData.append("dir", "icon/otherReward/");
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        formData
      );
      return { code: res.code, url: res.data };
    },
    // 展示提示消息
    showMsg(res) {
      if (res.code === 0) {
        this.$message({ type: "success", message: res.msg });
      } else {
        this.$message({ type: "warning", message: res.msg });
      }
    },
    handleDialogClose() {
      this.$emit("input", false);
    },
    handleInnerDialogClose() {
      this.editDialog.visible = false;
    },

    async submitUpdateReward(isEdit) {
      let res = null;
      if (isEdit) {
        res = await updateSignInDetailTable({
          channelList: [this.rowData.channel],
          valid: this.rowData.valid,
          checkInDays: this.rowData.days,
          checkInRewardList: [
            {
              rewardInfoId: this.editDialog.data.id,
              count: this.editDialog.data.nums,
              name: this.editDialog.data.name,
              icon: this.editDialog.data.icon,
              bigIcon: this.editDialog.data.bigIcon,
              rewardType: this.editDialog.data.type,
            },
          ],
        });
        this.editDialog.visible = false;
      } else {
        console.log(this.rowData);
        if (!this.formData.rewardType || !this.formData.count)
          return this.$message.error("奖品类型，数量不能为空");
        res = await updateSignInDetailTable({
          channelList: [this.rowData.channel],
          valid: this.rowData.valid,
          checkInDays: this.rowData.days,
          checkInRewardList: [this.formData],
        });
      }
      this.showMsg(res);
      this.getDetailList();
    },
    dialogShow(row) {
      console.log(row);
      this.editDialog.data = JSON.parse(JSON.stringify(row));
      this.editDialog.visible = true;
    },
    async getDetailList() {
      const res = await getSignInDetailTable({
        channel: this.rowData.channel,
        checkInDays: this.rowData.days,
        valid: this.rowData.valid,
      });
      this.showMsg(res);
      if (res.code === 0) {
        this.rewardDetailTable = res.data;
      }
    },
    deleteRowData(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await deleteSignInDetailTable(row.id);
        if (res.code === 0) {
          this.getDetailList();
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        } else {
          this.$message.error("删除失败");
        }
      });
    },
  },
  mounted() {
    console.log(this.rowData);
    this.getDetailList();
  },
};
</script>

<style lang="scss">
.main-text {
  font-size: 24px;
  margin: 10px 0 30px;
  font-weight: 600;
}
</style>
